module.exports = __webpack_public_path__ + "static/media/playlists-bold.fe594ca6.svg";